import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { GlobalMessageService, GlobalMessageType } from '../../../core/global-message';
import {
  CartType,
  CHECKOUT_ORDER_QUERY_PARAM_KEY,
  GpWebPayPaymentSetupParameters,
  GpWebPayPaymentSetupParametersTypes,
  PaymentProviderTypes,
} from '../../../core/model';
import { CART_TYPE_PARAM_KEY } from '../../../shared';
import { CheckoutFacade, CheckoutProcessingFacade } from '../../checkout/base';
import { CheckoutPaymentConnector } from '../../checkout/base/connector';

@Injectable({
  providedIn: 'root',
})
export class PaymentProcessingService {
  constructor(
    private readonly globalMessageService: GlobalMessageService,
    private readonly routingService: RoutingService,
    private readonly checkoutPaymentConnector: CheckoutPaymentConnector,
    private readonly checkoutProcessingService: CheckoutProcessingFacade,
    private readonly checkoutService: CheckoutFacade
  ) {}

  addErrorMessageAndRedirectToCart(cartType: CartType): void {
    this.globalMessageService.add(
      {
        key: 'checkout.problemWithYourPayment_message',
      },
      GlobalMessageType.MSG_TYPE_ERROR
    );

    this.routingService.go({ cxRoute: 'cart' }, { queryParams: { [CART_TYPE_PARAM_KEY]: cartType } });
  }

  redirectToOrderConfirmation(sapOrderNumber: string): void {
    this.routingService.go(
      { cxRoute: 'orderConfirmation' },
      {
        queryParams: {
          [CHECKOUT_ORDER_QUERY_PARAM_KEY]: sapOrderNumber,
        },
      }
    );
  }

  cancelCurrentOrderProcess(cartType: CartType, hybrisId: string): void {
    this.checkoutService.cancelActiveOrderProcess(hybrisId);
    this.checkoutProcessingService.clearActiveOrderProcess();
    this.checkoutProcessingService.dismissActiveOrderProcessModalIfExists();

    this.addErrorMessageAndRedirectToCart(cartType);
  }

  isCorrectPaymentProvider(provider: PaymentProviderTypes): boolean {
    return Object.values(PaymentProviderTypes).includes(provider as PaymentProviderTypes);
  }

  shouldSendProceedRequest(provider: PaymentProviderTypes): boolean {
    return [PaymentProviderTypes.GPWEBPAY].includes(provider);
  }

  sendProceedRequest(provider: PaymentProviderTypes, userId: string, orderCode: string, params: ParamMap): Observable<void> {
    switch (provider) {
      case PaymentProviderTypes.GPWEBPAY:
        return this.checkoutPaymentConnector.proceedGpWebPayPayment(userId, orderCode, this.convertParamsForGpWebPay(params));
      default:
        return throwError(`Proceed request for provider: ${provider} not supported`);
    }
  }

  private convertParamsForGpWebPay(params: ParamMap): GpWebPayPaymentSetupParameters {
    let gpWebPayParams: GpWebPayPaymentSetupParameters;

    Object.values(GpWebPayPaymentSetupParametersTypes).forEach((paramKey) => {
      const paramValue = params.get(paramKey);

      if (paramValue !== null) {
        gpWebPayParams = { ...gpWebPayParams, [paramKey]: paramValue };
      }
    });

    return gpWebPayParams;
  }
}
